import ApplicationAdapter from 'register-partners-js/adapters/application';

export default class SdkKycTokenAdapter extends ApplicationAdapter {
  pathForType() {
    return 'kyc_sdk_tokens';
  }
}
